import { GatsbyImage, getImage } from "gatsby-plugin-image"
import * as React from "react"
import styled, { css } from "styled-components"
import parse from "html-react-parser"

const Section = styled.section`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 2rem;
`

const Heading = styled.h2`
${
	(props) => {
		switch (props.mode) {
		case "dark":
			return css`
				color: white;
			`;
		default:
			return css`
				
			`;
		}
	}
}
`

const Background = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: -1;

	${
		(props) => {
			if (props.bgColor && props.bgColorEnd ) {
				return css`
					background: linear-gradient(180deg, ${props.bgColor} 0%, ${props.bgColorEnd} 100%);
				`;
			} else if (props.bgColor) {
				return css`
					background: ${props.bgColor};
				`;
			}
		}
	}

	.gatsby-image-wrapper {
		position: static !important;
		width: 100%;

		> div {
			width: 100% !important;
			max-width: none !important;
			object-fit: fill !important;
		}
	}
`

const TableWrapper = styled.div`
@media (max-width: 450px) {
	width: 100vw;
	height: fit-content;
	overflow: hidden;
}
`

const Table = styled.table`
	border-collapse: collapse;
	border: none;
	width: 100%;
	max-width: 1028px;
	margin: 1rem 1rem 4rem;

	tr, th, td {
		border: none;
		padding: 0.5rem 0;
	}

	@media (max-width: 450px) {
		min-width: calc(190vw - 4rem);
		transform: translateX(calc(2.1rem - 90vw));
		transition: transform 0.5s ease;

		&.left {
			transform: translateX(0);
		}

		caption {
			display: table-caption;

			padding: 0;
			width: 100%;

			h2 {
				display: block;
				max-width: calc(100vw - 2rem);
				margin-left: 0.25rem;
				margin-right: 0.25rem;
				transform: translateX(calc(45vw - 1.25rem));
				transition: transform 0.5s ease;
			}
		}

		&.left {
			h2 {
				transform: translateX(calc(-45vw + 1rem));
			}
		}
	}
`;

const Thead = styled.thead`
	background: transparent;

	th {
		padding-bottom: 1.5rem;
	}
`;

const Tbody = styled.tbody`
	tr:first-of-type {
		td, th {
			padding-top: 0;
		}

		th:before {
			position: absolute;
			content: "";
			display: block;
			width: 100%;
			aspect-ratio: 1;
			background: rgb(146, 155, 175);
			border-top-left-radius: 50%;
			border-top-right-radius: 50%;
			top: 0;
			transform: translateY(-50%);
			z-index: -1;
			left: 0;
		}
	}

	tr:last-of-type {
		th:after {
			position: absolute;
			content: "";
			display: block;
			width: 100%;
			height: auto;
			aspect-ratio: 1;
			background: rgb(146, 155, 175);
			bottom: 0;
			z-index: -1;
			transform: translateY(3rem);
			left: 0;
			clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 50% calc(100% - 3rem), 0% 100%, 0% 0%);
		}
`;

const Tr = styled.tr`
	height: 1px;

	td, th {
		height: inherit;
	}
`;

const Th = styled.th`
${
	(props) => {
		switch (props.mode) {
		case "dark":
			return css`
				color: #fff;
			`;
		default:
			return css`
				
			`;
		}
	}
}

	&:last-of-type {
		text-align: right;
	}

	> div,
	h3 {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	h3 {
		font-size: clamp(1.25rem, 0.5882rem + 1.7647vw, 2rem);
		margin-bottom: 0rem;
		font-family: "Noto Sans", Optima, Segoe, 'Segoe UI', Candara, Calibri, Helvetica, Arial, sans-serif;
	}
`;

const SubHeading = styled.span`
	font-size: clamp(1rem, 0.5588rem + 1.1765vw, 1.5rem);
	margin-top: 1rem;
	margin-bottom: 0;
	text-transform: uppercase;
	display: block;
${
	(props) => {
		switch (props.mode) {
		case "dark":
			return css`
				color: rgb(146, 155, 175);
			`;
		default:
			return css`
				
			`;
		}
	}
}
`;

const ThVS = styled.td`
	font-size: clamp(1.5rem, 0.1765rem + 3.5294vw, 3rem);
	line-height: 1;
	vetical-align: middle;

	div {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 1rem;
		background: #fff;
		border-radius: 50%;
		aspect-ratio: 1;
		width: fit-content;
		margin: 0 auto;
		letter-spacing: -0.1em;

		@media (max-width: 450px) {
			display: none;
		}
	}
`;

const Td = styled.td`
	&& > div {
		background: #fff;
		padding: 2rem;
		display: flex;
		flex-direction: column;
		justify-content: center;
		text-align: center;
		font-size: clamp(1rem, 0.5588rem + 1.1765vw, 1.5rem);
		line-height: 1.5;
		height: 100%;

		> :last-child {
			margin-bottom: 0;
		}
	}
`;

const BeforeAfterTd = styled.td`
	.gatsby-image-wrapper:first-of-type {
		margin-bottom: 0.5rem;
	}
`;

const TdVS = styled.th`
	&& {
		background: rgb(146, 155, 175);
		position: relative;
		width: 175px;
		max-width: 20vw;
		text-align: center;
		color: #fff;
		padding: 2rem 1rem;

		&:after {
			content: "";
			position: absolute;
			bottom: 0;
			width: calc(100% - 2rem);
			left: 1rem;
			height: 2px;
			background: #000;
		}

		.gatsby-image-wrapper {
			max-width: 50px;
			margin-bottom: 1rem;
		}

		@media (max-width: 680px) {
			> :not(.gatsby-image-wrapper) {
				// screen reader text so the copy can still be used for screen readers.
				clip: rect(1px, 1px, 1px, 1px);
				height: 1px;
				overflow: hidden;
				position: absolute !important;
				width: 1px;
				word-wrap:normal !important;
			}
		}

		:last-child {
			margin-bottom: 0;
		}
	}
`;

const ToggleWrapper = styled.div`
	display: none;
	pointer-events: none;
	z-index: 2;
	left: 0;
	top: 0;
	position: absolute;
	bottom: 0;
	height: 100%;
	width: 19vw;
	justify-content: center;
	align-items: flex-start;
	padding-top: 55%;
	padding-bottom: 8rem;
	transition: transform 0.5s ease;

	&:has(~ div > .left) {
		transform: translateX(calc(100vw - 100%));

		svg {
			transform: rotate(180deg);
		}
	}

	@media (max-width: 450px) {
		display: flex;
	}
`;

const Toggle = styled.button`
	display: none;
	background: #fff;
	border-radius: 50%;
	padding: 0.5rem;
	width: 60px;
	aspect-ratio: 1;
	position: sticky;
	top: 2rem;
	border: none;
	cursor: pointer;
	appearance: none;
	pointer-events: all;

	@media (max-width: 450px) {
		display: block;

		svg {
			width: 5vw;
		}
	}
`;



export const ComparisonCharts = (data) => {
	const { heading, columnHeadings, beforeAfterRow, rows, appearance } = data;
	const mode = appearance.isDark ? "dark" : "light";

	const clickHandler = (e) => {
		const section = e.target.closest("section");
		const table = section.querySelector("table");
		table.classList.toggle("left");
	}

	// Generate a random ID for the section.
	const sectionID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

	React.useEffect(() => {
		const section = document.getElementById(sectionID);
		const thead = section.querySelector("thead");
		const caption = section.querySelector("caption");
		const toggleWrapper = section.querySelector(".toggle-wrapper");
		
		const setPaddingTop = () => {
			let height = thead.offsetHeight - 30;

			if (caption) {
				height += caption.offsetHeight;
			}

			toggleWrapper.style.paddingTop = `${height}px`;
		}

		setPaddingTop();

		window.addEventListener("resize", setPaddingTop);

	}, [sectionID]);

	return (
		<Section mode={mode} id={sectionID}>
			<Background bgColor={appearance.backgroundColor} bgColorEnd={appearance.backgroundColorEnd}>
				{appearance.backgroundImage && <GatsbyImage image={getImage(appearance.backgroundImage.node.localFile)} alt="" />}
			</Background>
			<ToggleWrapper className="toggle-wrapper">
				<Toggle onClick={clickHandler} aria-label={`Toggle visible columns in ${heading} table`}>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg>
				</Toggle>
			</ToggleWrapper>
			<TableWrapper>
				<Table>
					{heading && <caption><Heading mode={mode}>{heading}</Heading></caption>}
					<Thead>
						<Tr>
							<Th scope="col" mode={mode}>
								<h3>
									{columnHeadings.left.heading && <span>{columnHeadings.left.heading}</span>}
									{columnHeadings.left.subHeading && <SubHeading mode={mode}>{columnHeadings.left.subHeading}</SubHeading>}
								</h3>
							</Th>
							<ThVS scope="col">
								<div>
									<span>VS.</span>
								</div>
							</ThVS>
							<Th scope="col" mode={mode}>
								<h3>
									{columnHeadings.right.heading && <span>{columnHeadings.right.heading}</span>}
									{columnHeadings.right.subHeading && <SubHeading mode={mode}>{columnHeadings.right.subHeading}</SubHeading>}
								</h3>
							</Th>
						</Tr>
					</Thead>
					<Tbody>
						{beforeAfterRow && (
							<Tr>
								<BeforeAfterTd>
									{beforeAfterRow.left.before && <GatsbyImage image={getImage(beforeAfterRow.left.before.node.localFile)} alt={beforeAfterRow.left.beforeAlt} />}
									{beforeAfterRow.left.after && <GatsbyImage image={getImage(beforeAfterRow.left.after.node.localFile)} alt={beforeAfterRow.left.afterAlt} />}
								</BeforeAfterTd>
								<TdVS scope="row">
									{beforeAfterRow.center.icon && <GatsbyImage image={getImage(beforeAfterRow.center.icon.node.localFile)} alt={beforeAfterRow.center.iconAlt} />}
									{beforeAfterRow.center.text && <p>{beforeAfterRow.center.text}</p>}
								</TdVS>
								<BeforeAfterTd>
								{beforeAfterRow.right.before && <GatsbyImage image={getImage(beforeAfterRow.right.before.node.localFile)} alt={beforeAfterRow.right.beforeAlt} />}
								{beforeAfterRow.right.after && <GatsbyImage image={getImage(beforeAfterRow.right.after.node.localFile)} alt={beforeAfterRow.right.afterAlt} />}
								</BeforeAfterTd>
							</Tr>
						)}
						{rows.map((row, index) => (
							<Tr key={index}>
								<Td><div>{parse( row.left )}</div></Td>
								<TdVS scope="row">
								{row.center.icon && <GatsbyImage image={getImage(row.center.icon.node.localFile)} alt={row.center.iconAlt} />}
									{row.center.text && <p>{row.center.text}</p>}
								</TdVS>
								<Td><div>{parse( row.right )}</div></Td>
							</Tr>
						))}
					</Tbody>
				</Table>
			</TableWrapper>
		</Section>
	)
}
